import { Link } from "react-router-dom";
import { UtensilsCrossed, Download } from "lucide-react";
import { CUISINE_ORDER, metaFor } from "@/lib/cuisines";
import { API } from "@/lib/api";

export const Footer = () => (
  <footer className="border-t border-gray-100 mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
        <div className="max-w-md">
          <div className="flex items-center gap-2 mb-4">
            <UtensilsCrossed className="h-5 w-5" />
            <span className="font-heading text-2xl font-semibold">Pan &amp; Pantry</span>
          </div>
          <p className="text-sm text-gray-500 font-light leading-relaxed">
            Cheap, beginner-friendly recipes from around the world. Everything here needs
            nothing more than a pan, a knife and a hungry appetite.
          </p>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3">
          {CUISINE_ORDER.map((key) => {
            const meta = metaFor(key);
            return (
              <Link
                key={key}
                to={`/cuisine/${key}`}
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900"
              >
                <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
                {meta.name}
              </Link>
            );
          })}
          <a
            href={`${API}/cookbook.pdf`}
            data-testid="footer-download-cookbook"
            className="flex items-center gap-2 text-sm font-semibold text-gray-900 hover:text-gray-600"
          >
            <Download className="h-4 w-4" />
            Cookbook PDF
          </a>
        </div>
      </div>
      <p className="mt-12 text-xs text-gray-400">
        © {new Date().getFullYear()} Pan &amp; Pantry. A simple global cookbook.
      </p>
      <p className="mt-2 text-xs text-gray-500" data-testid="footer-creator">
        Created by <span className="font-semibold text-gray-700">Aarav Gautam</span>
      </p>
    </div>
  </footer>
);
